import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  CreateFulfillmentOrderErrorResponse,
  CreateFulfillmentOrderRequest,
  CreateFulfillmentOrderSuccessResponse
} from './createFulfillmentOrder.types'

export const createFulfillmentOrderApi = async (
  request: CreateFulfillmentOrderRequest
): Promise<CreateFulfillmentOrderSuccessResponse> => {
  const formData = new FormData()

  const packageJsonString = JSON.stringify(request.package)
  const itemsJsonString = JSON.stringify(
    request.items.map((item) => ({
      description: item.description,
      quantity: item.quantity ?? 1,
      ...(item.weightGrams != null ? { weightGrams: item.weightGrams } : {}),
      declaredValueCents: item.declaredValueCents,
      fragile: item.fragile,
      repackagingAllowed: item.repackagingAllowed,
      specialInstructions: item.specialInstructions
    }))
  )

  const recipientJsonString = JSON.stringify(request.recipient)

  formData.append('paymentIntentId', request.paymentIntentId)
  formData.append('package', packageJsonString)
  formData.append('items', itemsJsonString)
  formData.append('recipient', recipientJsonString)

  request.items.forEach((item) => {
    if (item.imageFile) {
      formData.append('itemPhotos', item.imageFile)
    }
  })

  const customHeaders: Record<string, string> = {
    'X-User-Role': UserRole.sender
  }

  const response = await configureRequest({
    url: urls.fulfillmentOrders.createFulfillmentOrder,
    method: 'POST',
    data: formData,
    headers: customHeaders
  })

  if (response.status >= 200 && response.status < 300) {
    return response as CreateFulfillmentOrderSuccessResponse
  } else {
    throw response as CreateFulfillmentOrderErrorResponse
  }
}

export default createFulfillmentOrderApi
